import moment from 'moment';
import { getVersion } from '../components/util/all';

export class Client {
  id?: number;

  name: string;

  email: string;

  phone: string;

  website: string;

  logo: string | null;

  watermark: string | null;

  rtl: boolean;

  facebook: string;

  instagram: string;

  twitter: string;

  linkedin: string;

  tours: any[];

  updatedAt: any;

  widthLogo: boolean;

  folders: any[];

  videoCredits: number;

  monthlyVideoCredits: number;

  subscriptionId: string;

  subscriptionType: string;

  user: any;

  clientPermission: any;

  paypalClientId?: string;

  whitelabelLogo: boolean;

  whitelabelId: string;

  primaryColor: string;

  secondaryColor: string;

  googleViewId: string;

  fbPixel: string;

  meetingSlotMinutes: number;

  meetingSlotPpl: number;

  hubMinutes: number;
  fbAppId: string;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.linkedin = model.linkedin || null;
    this.facebook = model.facebook || null;
    this.instagram = model.instagram || null;
    this.twitter = model.twitter || null;
    this.fbAppId = model.fbAppId || null;

    this.whitelabelId = model.whitelabelId || null;
    this.whitelabelLogo = model.whitelabelLogo || null;
    this.rtl = model.rtl || false;
    this.googleViewId = model.googleViewId || null;
    this.fbPixel = model.fbPixel || null;
    this.tours = model.tours || [];
    this.updatedAt = model.updatedAt ? moment(model.updatedAt) : moment();
    this.logo =
      this.id && model.logo
        ? `${process.env.NEXT_PUBLIC_CDN}/clients/${this.id}/logo.png${getVersion(this.updatedAt)}`
        : null;
    this.watermark =
      this.id && model.watermark
        ? `${process.env.NEXT_PUBLIC_CDN}/clients/${this.id}/watermark.png${getVersion(
            this.updatedAt,
          )}`
        : null;
    this.widthLogo = model.widthLogo || false;
    this.folders = model.folders || [];
    this.videoCredits = model.videoCredits || 0;
    this.monthlyVideoCredits = model.monthlyVideoCredits || 0;
    this.subscriptionId = model.subscriptionId || null;
    this.user = model.user || null;
    this.subscriptionType = model.subscriptionType || null;
    this.clientPermission = model.clientPermission || {};
    this.paypalClientId = model.paypalClientId || null;
    this.primaryColor = model.primaryColor || '#292929';
    this.secondaryColor = model.secondaryColor || '#ea475c';
    this.meetingSlotMinutes = model.meetingSlotMinutes || 10;
    this.meetingSlotPpl = model.meetingSlotPpl || 5;
    this.hubMinutes = model.hubMinutes || 0;
  }
}
